module.exports = __webpack_public_path__ + "static/media/Chengu Kargbo.CV 2026.d67bc7cb.pdf";